export default {"src":"/_next/static/media/dollar.44cff0bb.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};